<router-outlet />
<router-outlet name="popup" />

@if (isMazeAnalyticsEnabled) {
  <ikp-maze />
}
